import { all } from 'redux-saga/effects';

// import {sagas as commonSagas} from "@store/common";
// import { sagas as dimensionTablesSagas } from '@store/dimensionTables';
import { sagas as filterContainerContainerSagas } from '@store/filterContainer';

// import { sagas as trendsSagas } from '@store/trends';
// import { sagas as errorConfigSagas } from '@store/errorLogicConfig';

export default function* rootSaga() {
  yield all([
    ...filterContainerContainerSagas.map((saga) => saga()),
    // ...commonSagas.map(saga => saga()),
    // ...dimensionTablesSagas.map(saga => saga()),
    // ...trendsSagas.map(saga => saga()),
    // ...errorConfigSagas.map(saga => saga()),
  ]);
}
